// tkpc-bundler-i18n.js
(() => {
  "use strict";

  // ✅ SOLO en tu página del bundle (en cualquier idioma: /ca/pages/... /en/pages/... /pages/...)
  const BUNDLE_SLUG = "crea-tu-pack-de-2-journals";
  if (!location.pathname.includes(`/pages/${BUNDLE_SLUG}`)) return;

  function getLang() {
    const shopify = (window.Shopify && Shopify.locale) ? String(Shopify.locale) : "";
    const pathLang = (location.pathname.split("/")[1] || "").toLowerCase(); // ca / en / ...
    const htmlLang = (document.documentElement.lang || "").slice(0, 2).toLowerCase();

    const lang = (shopify || pathLang || htmlLang || "es").slice(0, 2).toLowerCase();
    return ["es", "ca", "en"].includes(lang) ? lang : "es";
  }

  const STR = {
    es: {
      title: "Iguales o distintos, tú decides.",
      model: "Modelo",
      choose2: "Elige 2 más",
      choose1: "Elige 1 más",
      add: "Añadir",
      addCart: "Pack completo — Añadir al carrito",
    },
    ca: {
      title: "Iguals o diferents, tu decideixes.",
      model: "Model",
      choose2: "Tria'n 2 més",
      choose1: "Tria'n 1 més",
      add: "Afegir",
      addCart: "Pack complet — Afegir al carret",
    },
    en: {
      title: "Same or different, you decide.",
      model: "Model",
      choose2: "Choose 2 more",
      choose1: "Choose 1 more",
      add: "Add",
      addCart: "Complete pack — Add to cart",
    }
  };

  // Normaliza espacios raros
  function norm(s) {
    return String(s).replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();
  }

  function replaceText(original, t) {
    let s = original;

    // 1) Título
    if (norm(s).toLowerCase() === "iguales o distintos, tú decides.") return t.title;
    if (norm(s).toLowerCase() === "iguals o diferents, tu decideixes.") return t.title;
    if (norm(s).toLowerCase() === "same or different, you decide.") return t.title;

    // 2) "Modelo X" -> "Model X" / "Model X"
    // OJO: solo sustituimos la palabra "Modelo" cuando aparece como palabra completa
    s = s.replace(/\bModelo\b/g, t.model);
    s = s.replace(/\bModel\b/g, t.model);

    // 3) Elige/Tria/Choose
    const n = norm(s);
    if (n === "Elige 2 más" || n === "Tria'n 2 més" || n === "Choose 2 more") return t.choose2;
    if (n === "Elige 1 más" || n === "Tria'n 1 més" || n === "Choose 1 more") return t.choose1;

    // 4) Añadir / Afegir / Add
    if (n === "Añadir" || n === "Afegir" || n === "Add") return t.add;

    // 5) Pack completo — Añadir al carrito (variaciones)
    const low = n.toLowerCase();
    const isPack = low.includes("pack completo") || low.includes("pack complet") || low.includes("complete pack");
    const isCart = low.includes("carrito") || low.includes("carret") || low.includes("cart");
    if (isPack && isCart) return t.addCart;

    return s;
  }

  function translate() {
    const lang = getLang();
    const t = STR[lang] || STR.es;

    // Scope: el contenido principal de la página
    const root =
      document.querySelector("#MainContent") ||
      document.querySelector("main") ||
      document.body;

    if (!root) return;

    // Recorremos TEXT NODES (esto evita el problema de "Modelo X\nAñadir" dentro de un div)
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        const tag = p.tagName;
        if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT") return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const toChange = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const raw = node.nodeValue;
      if (!raw) continue;

      const next = replaceText(raw, t);
      if (next !== raw) toChange.push([node, next]);
    }

    toChange.forEach(([node, next]) => { node.nodeValue = next; });
  }

  // Ejecuta varias veces al cargar (Bundler pinta async)
  translate();
  setTimeout(translate, 300);
  setTimeout(translate, 800);
  setTimeout(translate, 1500);

  // Y cuando el DOM cambie
  const obs = new MutationObserver(() => translate());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  window.TKPC_I18N_LOADED = true;
})();
